import {useTypedSelector} from "../../../../hooks/useTypedSelector";

function Rank() {

    const {user} = useTypedSelector(state => state.auth);

    const rankClass = user.rank.rank + 'Rank';

    const step = user.rank.total_score / 6;
    let fillNumber = Math.round(user.rank.score / step);


    const fill = ' rank' + user.rank.rank + 'Fill';
    const empty = ' rank' + user.rank.rank + 'Empty';
    const rankFirstPointClass = (1 <= fillNumber) ? fill : empty;
    const rankSecondPointClass = (2 <= fillNumber) ? fill : empty;
    const rankThreePointClass = (3 <= fillNumber) ? fill : empty;
    const rankFourPointClass = (6 <= fillNumber) ? fill : empty;
    const rankFivePointClass = (5 <= fillNumber) ? fill : empty;
    const rankSixPointClass = (4 <= fillNumber) ? fill : empty;

    return <div className={'rankMainContainer'}>
        <div className={'rankCaption'}>Current Rank</div>
        <div className={'rankMainContainerLeft'}>
            <div className={'rankContainer ' + rankClass}>
                {(user.rank.rank !== 'champions') ?
                    <div className={'rankPointContainer'}>
                        <div className={'rankPoint rankFirstPoint' + rankFirstPointClass}></div>
                        <div className={'rankPoint rankSecondPoint' + rankSecondPointClass}></div>
                        <div className={'rankPoint rankThreePoint' + rankThreePointClass}></div>
                        <div className={'rankPoint rankFourPoint' + rankFourPointClass}></div>
                        <div className={'rankPoint rankFivePoint' + rankFivePointClass}></div>
                        <div className={'rankPoint rankSixPoint' + rankSixPointClass}></div>
                    </div>
                    : <div></div>
                }
            </div>
        </div>


    </div>
}

export default Rank;